import consumer from "./consumer"

consumer.subscriptions.create("CompletePercentageChannel", {
  received(data) {
    const { percentage_type, csv_file_id, folder_id, percentage } = data;
    if (percentage_type == "csv_upload") {
      const percentageElement = document.querySelector(`.csv-upload-percentage-${csv_file_id}`);
      if (percentageElement) {
        percentageElement.textContent = percentage;
      }
    } else if (percentage_type == "csv_merge") {
      const percentageElement = document.querySelector(`.merging-status-${folder_id}`);
      if (percentageElement) {
        percentageElement.textContent = percentage;
      }
    } else if (percentage_type == "csv_verify") {
      const percentageElement = document.querySelector(`.csv-verify-percentage-${folder_id}`);
      if (percentageElement) {
        percentageElement.textContent = percentage;
      }
    }
  }
});
